/**
 * Заголовок вкладки браузера для пути. Побеждает первое совпадение, поэтому частные пути
 * стоят выше общих; нет совпадения — «Обучение».
 */
const TITLES: Array<[RegExp, string]> = [
  [/^\/admin\/board/, 'Назначения'],
  [/^\/admin\/assignments/, 'Массовые назначения'],
  [/^\/admin\/questions/, 'Банк вопросов'],
  // Вкладки админ-панели и видео-управление: у каждой страницы свой заголовок вкладки браузера
  [/^\/admin\/users/, 'Пользователи'],
  [/^\/admin\/statistics/, 'Статистика'],
  [/^\/admin\/dashboards/, 'Дашборды'],
  [/^\/admin\/news/, 'Новости админки'],
  [/^\/admin\/videos/, 'Управление видеопорталом'],
  // Рабочее место «Тесты». Прежний экран вопросов теста остаётся «Администрированием»
  [/^\/admin\/tests\/\d+\/questions\/?$/, 'Администрирование'],
  [/^\/admin\/tests\/(?:new|\d+)\/questions\/add/, 'Готовые вопросы'],
  [/^\/admin\/tests\/new/, 'Создание теста'],
  [/^\/admin\/tests\/\d+\/assign/, 'Кому дать тест'],
  [/^\/admin\/tests\/\d+/, 'Тест'],
  [/^\/admin\/tests/, 'Тесты'],
  [/^\/admin/, 'Администрирование'],
  [/^\/results/, 'Мои результаты'],
  [/^\/tests\/\d+/, 'Прохождение теста'],
  [/^\/tests/, 'Доступные тесты'],
  [/^\/videos/, 'Видеопортал'],
  [/^\/login/, 'Вход'],
  [/^\/$/, 'Главная'],
];

export function resolveDocumentTitle(pathname: string): string {
  return TITLES.find(([pattern]) => pattern.test(pathname))?.[1] || 'Обучение';
}
